import React, { useState, useRef, useEffect } from 'react';
import './style.scss';
import { FILTER_TABS } from '../../hooks/useFilterBar';

const TAB_OPTIONS = [
  FILTER_TABS.ALL,
  FILTER_TABS.ACTIVE,
  FILTER_TABS.VERIFIED,
  FILTER_TABS.UNPAID,
  FILTER_TABS.PENDING,
  FILTER_TABS.COLLECTED,
  FILTER_TABS.CANCEL,
  FILTER_TABS.REFUND
];

export default function FilterBar({ activeTab, setActiveTab, ordersCount }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="feed-header">
      <span className="feed-header-count">{ordersCount} {ordersCount === 1 ? 'ORDER' : 'ORDERS'}</span>
      <div className="filter-dropdown-wrap" ref={menuRef}>
        <button
          type="button"
          className={`filter-btn ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="8" y1="12" x2="16" y2="12" />
            <line x1="11" y1="18" x2="13" y2="18" />
          </svg>
          <span>{activeTab}</span>
        </button>

        {isOpen && (
          <div className="filter-menu">
            {TAB_OPTIONS.map((tab) => (
              <div
                key={tab}
                className={`filter-menu-item ${activeTab === tab ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(tab);
                  setIsOpen(false);
                }}
              >
                {tab}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
